// Generated by ReScript, PLEASE EDIT WITH CARE

import * as FraudType from "../../../view/components/types/FraudType.bs.js";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as BlacklistType from "../../../view/components/types/BlacklistType.bs.js";
import * as BlacklistPartnerPayloadApiModel from "../api-model/BlacklistPartnerPayloadApiModel.bs.js";

function entityToApiModel(entity) {
  return {
          msisdn: entity.msisdn,
          fraudType: FraudType.toApiValue(entity.fraudType),
          blacklistTypes: Belt_Array.map(entity.blacklistTypes, BlacklistType.toApiValue),
          comment: entity.comment
        };
}

function execute(entity) {
  return BlacklistPartnerPayloadApiModel.t_encode(entityToApiModel(entity));
}

export {
  entityToApiModel ,
  execute ,
  
}
/* No side effect */
